<app-toolbar [token]="token" [breadcrumbs]="breadcrumbs" [ProcedureValue]="ProcedureValue"></app-toolbar>

<div *ngIf="!isPathPatternSections">
  <table mat-table [dataSource]="pathPatterns" class="mat-elevation-z8" class="table-container">

    <ng-container matColumnDef="Id">
      <th mat-header-cell *matHeaderCellDef> Identificador </th>
      <td mat-cell *matCellDef="let element"> {{element.PathPatternId}} </td>
    </ng-container>

    <ng-container matColumnDef="Nombre">
      <th mat-header-cell *matHeaderCellDef> Nombre </th>
      <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
    </ng-container>

    <ng-container matColumnDef="Tipo de Patron">
      <th mat-header-cell *matHeaderCellDef> Tipo de Patron </th>
      <td mat-cell *matCellDef="let element"> {{element.PathPatternType}} </td>
    </ng-container>

    <ng-container matColumnDef="Plataformas de Conferencias">
      <th mat-header-cell *matHeaderCellDef> Plataformas de Conferencias </th>
      <td mat-cell *matCellDef="let element"> {{element.ConferencingPlatform}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="onRowClick(element.PathPatternId)">
          <mat-icon>add_circle</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsPathPattern"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsPathPattern;"></tr>

  </table>
</div>


<div *ngIf="isPathPatternSections">

  <button mat-icon-button class="btn-back" (click)="back()">
    <mat-icon>arrow_back</mat-icon>
    Regresar
  </button>

  <table mat-table [dataSource]="pathPatternsSections" class="mat-elevation-z8" class="table-container">

    <ng-container matColumnDef="Tipo de Sección">
      <th mat-header-cell *matHeaderCellDef> Tipo de Sección </th>
      <td mat-cell *matCellDef="let element"> {{element.PathPatternSectionType}} </td>
    </ng-container>

    <ng-container matColumnDef="Es editable">
      <th mat-header-cell *matHeaderCellDef> Es editable </th>
      <td mat-cell *matCellDef="let element"> {{element.AllowEdit}} </td>
    </ng-container>

    <ng-container matColumnDef="Sección del patrón">
      <th mat-header-cell *matHeaderCellDef> Sección del patrón </th>
      <td mat-cell *matCellDef="let element"> {{element.PatternSection}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <a mat-menu-item routerLink="/edit_routes/{{pathPatternId}}/{{element.PathPatternSectionId}}" class="edit-link" *ngIf="element.AllowEdit!='No'">
          Editar
          <mat-icon>edit</mat-icon>
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsPathPatternSections"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsPathPatternSections;"></tr>

  </table>
</div>
